export default __webpack_public_path__ + "static/media/tomato.d50f6e4c.png";